import ahoy from 'ahoy.js'
import cfHoy from '@clickfunnels2/cfhoy.js'

let livePage = isLivePage(window.location.search)
let trackingDisabled = window.disableTracking

// ahoy
if (!trackingDisabled) {
  document.addEventListener('DOMContentLoaded', function () {
    if (livePage) {
      ahoy.trackView({ cf_cid: $.cookie('cf_cid') || '' })

      $(document).on('click', '[event-tracking="enable"]', function () {
        const trackingEvent = `${window.location.pathname} --- ${$(this).text()}`

        const data = {
          url: window.location.href,
          page: window.location.pathname,
          title: document.title,
        }

        ahoy.track(trackingEvent, data)
      })
    }
  })

  // cfhoy
  if (window.eventsApiURL && livePage) {
    // we need to configure ahoy before DOMContentLoaded event
    // so it can track the visit correctly
    cfHoy.configure({
      urlPrefix: window.eventsApiURL,
      visitsUrl: '/visits',
      eventsUrl: '/events',
      platform: 'Web',
      useBeacon: true,
      startOnReady: true,
      trackVisits: true,
      cookies: true,
      withCredentials: false,
      visitDuration: 4 * 60, // 4 hours
      visitorDuration: 2 * 365 * 24 * 60, // 2 years
    })

    document.addEventListener('DOMContentLoaded', function (event) {
      cfHoy.trackClicks()
      cfHoy.trackSubmits()
      cfHoy.trackChanges()
      cfHoy.trackView({ cf_cid: $.cookie('cf_cid') || '' })

      $(document).on('click', '[event-tracking="enable"]', function () {
        const data = {
          url: window.location.href,
          page: window.location.pathname,
          title: document.title,
        }

        cfHoy.track('click-custom-button', data)
      })
    })
  }
}

function isLivePage(queryString) {
  const urlParams = new URLSearchParams(queryString)
  return urlParams.get('preview') !== 'true'
}
